import { render, staticRenderFns } from "./ConfigExpiracaoLead.vue?vue&type=template&id=7c032f84&scoped=true&"
import script from "./ConfigExpiracaoLead.vue?vue&type=script&lang=js&"
export * from "./ConfigExpiracaoLead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c032f84",
  null
  
)

export default component.exports